export default __webpack_public_path__ + "static/media/graph1.cec3cb70.png";